import React, {Component} from 'react';
import styles from './FeedListItem.module.css';
import DefaultProfileImg from '../../../../shared/project-info/images/DefaultProfileImg.png';
import LikeIcon from '../svgs/LikeIcon';
import AdminIcon from '../svgs/AdminIcon';
import EnhancedCard from './EnhancedCard';
import {howLongAgo, getHyperlinks} from '../../../../shared/utils/Helpers';
import {rwbApi} from '../../../../shared/apis/api';
import {Link, withRouter} from 'react-router-dom';
import FormattedPostText from './FormattedPostText';
import AggregatePostTitle from './AggregatePostTitle';
import {userProfile} from '../../../../shared/models/UserProfile';
import {
  logEventReactPost,
  logFeedReactPost,
} from '../../../../shared/models/Analytics';
import ReportAndDeleteOverlay from '../ReportAndDeleteOverlay';
import {
  POST_BLOCK_ERROR,
  POST_DELETE_ERROR,
  STREAM_ERRORS,
} from '../../../../shared/constants/ErrorMessages';
import ListItemTitle from './ListItemTitle';
import PhotoView from './PhotoView';
import PinnedPostIcon from '../svgs/PinnedPostIcon';
import ShareChallengeBox from './ShareChallengeBox';
import {
  POST_BLOCK_WARNING,
  POST_DELETE_WARNING,
} from '../../../../shared/constants/OtherMessages';
import {deletePost} from '../../../../shared/utils/StreamHelpers';
import {errorAlert} from '../../../../shared/utils/ErrorAlert';
import SitePreviewCard from '../SitePreviewCard.react';
import { projectConfig } from '../../../../shared/project-info/projectConfig';
import { tenantProjectInfo } from '../../../../shared/models/TenantProjectInfo';

class AggregateFeedListItem extends Component {
  constructor(props) {
    super(props);
    const {data, origin} = props;
    this.postType = data.foreign_id.split(':')[0];
    this.type = this.props.type;
    if (!this.props.type) {
      if (data?.object?.kind || data?.object?.type) {
        this.type = data?.object?.kind || data?.object?.type;
      }
      else if (typeof(data?.object) === 'string') {
        this.type = data?.object.split(':')[0];
      }
      else {
        this.type = data?.foreign_id?.split('.')[1]?.split(':'[0]?.toLowerCase());
      }
    }
    this.eventID = this.props.eventID || (data.event && data.event.id);
    this.streamID = data.id;
    this.reactable = this.postType !== 'attend'; // can only react to posts that can only be "single" (create, post, etc)
    this.origin =
      (data.origin && data.origin.split(':')[0]) ||
      origin ||
      null;
    this.state = {
      loaded: false,
      deleted: false, //set to true when deleting and reverted on server failure
      liked:
        this.props.data.own_reactions &&
        this.props.data.own_reactions.like, // if own_reactions.like, that means the post has been liked
      likeAmount:
        (this.props.data.reaction_counts &&
          this.props.data.reaction_counts.like) ||
        0,
      changingLikeStatus: false,
      commentAmount:
        this.props.data.reaction_counts?.comment || 0,
      isModalOpen: false,
      tallImg: false,
    };
  }

  // navigating means the value is being sent to a different page
  displayTitle = (navigating) => {
    // will need to add a check for event name after enrichment
    const {history} = this.props;
    const {verb, event, group, challenge} = this.props.data;
    return ListItemTitle(history, navigating, this.type, verb, event, group, challenge);
  };

  // only the creator of a post can delete
  // "event" types are statuses, and those cannot be deleted
  canDelete = () => {
    const postCreator = this.props.data.actor.id; //ID of post creator
    const currentUserID = userProfile.getUserProfile().id;
    return postCreator == currentUserID && this.type !== 'event';
  };

  deletePost = () => {
    if (window.confirm(`Delete Post: ${POST_DELETE_WARNING}`)) {
      const activity = this.props.data;
      const streamID = activity.id;
      const eventID = activity?.event_id;
      const challengeID = activity?.challenge?.id || activity?.challenge_id;
      const groupID = activity?.group?.id || activity?.group_id;
      this.setState({deleted: true});
      deletePost(streamID, eventID, challengeID, groupID).catch(() => {
        errorAlert(POST_DELETE_ERROR);
        this.setState({deleted: false});
      });
    }
  };

  blockPost = () => {
    if (window.confirm(`Block Post: ${POST_BLOCK_WARNING}`)) {
      if (!this.props.data.event_id) {
        this.setState({deleted: true});
        rwbApi
          .blockPost(this.props.data.id)
          .then(() => {
            // hide post
          })
          .catch(() => {
            errorAlert(POST_BLOCK_ERROR);
            this.setState({deleted: false});
          });
      }
    }
  };

  updateLikeStatus = (action) => {
    if (action === 'like') {
      const likeAmount = this.state.likeAmount + 1;
      this.setState({liked: true, likeAmount});
      if (this.props.updatePostLike) this.props.updatePostLike(this.streamID, true, likeAmount);
    } else if (action === 'unlike') {
      const likeAmount = this.state.likeAmount - 1;
      this.setState({liked: false, likeAmount});
      if (this.props.updatePostLike) this.props.updatePostLike(this.streamID, false, likeAmount);
    }
  };

  updateCommentCount = (commentAmount) => {
    this.setState({commentAmount});
    if (this.props.updatePostComment) this.props.updatePostComment(this.streamID, commentAmount);
  };

  handleLikePost = () => {
    if (this.state.changingLikeStatus) return;
    this.setState({changingLikeStatus: true});
    const reactionKind = JSON.stringify({kind: 'like'});
    // posts on events are 'event_post's, but do not have an ID. Do not treat it like an event post
    if (
      this.postType === 'event_post' &&
      this.eventID &&
      this.origin !== 'user'
    ) {
      this.eventPostLike(reactionKind);
    }
    // other postTypes might be "attend",
    else this.userPostLike(reactionKind);
  };

  onImgLoad = ({target: img}) => {
    if (img.offsetWidth / img.offsetHeight < 0.75) {
      this.setState({tallImg: true});
    }
  };

  // NOTE: This function is not called on web despite liking the same event post as on mobile (where it is called)
  eventPostLike = (reactionKind) => {
    if (!this.state.liked) {
      this.updateLikeStatus('like');
      rwbApi
        .postEventReaction(this.eventID, this.streamID, reactionKind)
        .then(() => {
          logEventReactPost();
        })
        .catch((err) => {
          if (err === STREAM_ERRORS.ALREADY_REACTED)
            alert("You've already liked this post. Please refresh your feed.");
          else alert('Error liking post. Please try again later.');
          this.updateLikeStatus('unlike');
        }).finally(() => {
          this.setState({changingLikeStatus: false});
        });
    } else {
      this.updateLikeStatus('unlike');
      rwbApi
        .deleteEventReaction(this.eventID, this.streamID, reactionKind)
        .then(() => {})
        .catch((err) => {
          if (err === STREAM_ERRORS.REACTION_NOT_FOUND)
            alert(
              "You've already unliked this post or it was deleted. Please refresh your feed.",
            );
          else alert('Error unliking post. Please try again later.');
          this.updateLikeStatus('like');
        }).finally(() => {
          this.setState({changingLikeStatus: false});
        });
    }
  };

  determinePostRoute = () => {
    const {group_id, event_id, challenge_id, id} = this.props.data;
    const {origin} = this.props;
    if (group_id && origin !== 'user') {
      return `/groups/${group_id}/feed/${id}`;
    } else if (event_id && origin !== 'user') {
      return `/events/${event_id}/feed/${id}`;
    } else if (challenge_id && origin !== 'user') {
      return `/challenges/${challenge_id}/feed/${id}`;
    } else return `/feed/${id}`;
  };

  navigationState = () => {
    const {
      id,
      time,
      text,
      object,
      media_url,
      tagged,
      is_pinned,
      actor,
      open_graph,
    } = this.props.data;
    const event = object;
    const {liked, likeAmount, deleted, commentAmount, isModalOpen} = this.state;
    return (
      {
          post_image: media_url,
          text,
          poster: actor,
          time,
          tagged,
          eventID: this.eventID || null,
          streamID: id,
          liked,
          likeAmount,
          title: this.displayTitle(true),
          eventName: event ? event.name : null,
          actorID: actor.id,
          activityID: id,
          commentAmount,
        }
    )
  }

  // for timeline/feed posts
  userPostLike = (reactionKind) => {
    const creatorID = this.props.data.actor.id;
    if (!this.state.liked) {
      this.updateLikeStatus('like');
      rwbApi
        .postReaction(creatorID, this.streamID, reactionKind)
        .then((result) => {
          logFeedReactPost();
        })
        .catch((err) => {
          if (err === STREAM_ERRORS.ALREADY_REACTED)
            alert("You've already liked this post. Please refresh your feed.");
          else alert('Error liking post. Please try again later.');
          this.updateLikeStatus('unlike');
        }).finally(() => {
          this.setState({changingLikeStatus: false});
        });
    } else {
      this.updateLikeStatus('unlike');
      rwbApi
        .deleteReaction(creatorID, this.streamID, reactionKind)
        .then(() => {})
        .catch((err) => {
          if (err === STREAM_ERRORS.REACTION_NOT_FOUND)
            alert(
              "You've already unliked this post or it was deleted. Please refresh your feed.",
            );
          else alert('Error unliking post. Please try again later.');
          this.updateLikeStatus('like');
        }).finally(() => {
          this.setState({changingLikeStatus: false});
        });
    }
  };

  handleClickLikeList = (e) => {
    if(projectConfig.canViewLikeList === false) return;

    e.preventDefault();
    e.stopPropagation();
  
    // This component can receive data in two shapes depending on whether it's in a flat feed or aggregated feed
    const activity = this.props.data.activities?.[0] || this.props.data;
  
    if (!activity) {
      console.error("No valid activity found in this.props.data:", this.props.data);
      return;
    }
  
    const id = activity.id;
    const user = activity.actor; // `actor` is always present in both data shapes
  
    if (!id || !user) {
      console.error("Missing id or user in activity:", activity);
      return;
    }
  
    this.props.history.push({
      pathname: `/feed/${id}/like`,
      state: {
        feed: {
          id,
          user,
        },
      },
    });
  };  

  render() {
    const {
      id,
      time,
      text,
      object,
      media_url,
      tagged,
      is_pinned,
      actor,
      open_graph,
    } = this.props.data;
    const event = object;
    const {liked, likeAmount, deleted, commentAmount, isModalOpen} = this.state;
    const {history} = this.props;
    const links = getHyperlinks(text);
    return !deleted ? (
      <div className={styles.container}>
        <div className={styles.userActivityContainer}>
          <div className={styles.imageAndTextContainer}>
            <div
              className={styles.userImageContainer}
              onClick={() => history.push(`/profile/${actor.id}`)}>
              <img
                className={styles.profileImage}
                src={actor?.profile_photo_url || DefaultProfileImg}
                alt="User Profile Image"
              />
              {/* only show on a sponsor group the poster is an admin of */}
            {this.props.isSponsor && actor?.is_sponsor_admin && (
              <AdminIcon className={styles.sponsorAdminIcon} />
            )}
            </div>
            <div>
              {this.reactable ? (
                <span>
                  <span
                    className={`namesAndObjects ${styles.name}`}
                    onClick={() => history.push(`/profile/${actor.id}`)}>
                    {`${actor.first_name} ${actor.last_name}`}&nbsp;
                  </span>
                  {this.displayTitle(false)}&nbsp;
                </span>
              ) : (
                <AggregatePostTitle
                  activities={this.props.data.activities}
                  history={history}
                />
              )}
              <span className="namesAndObjects">&nbsp;</span>•{' '}
              {howLongAgo(time)}
              {this.props.data?.edited && (
                <p className={'edited'}> Edited</p>
              )}
            </div>
          </div>
          <div style={{alignSelf: 'flex-start', display: 'flex'}}>
            {is_pinned ? (
              <div className={styles.pinnedContainer}>
                <h4 className={styles.pinnedPostText}>PINNED POST</h4>
                {/* placeholder svg */}
                <PinnedPostIcon width="20px" height="20px" />
              </div>
            ) : null}
            <ReportAndDeleteOverlay
              canDelete={this.canDelete}
              deletePost={this.deletePost}
              blockPost={this.blockPost}
              streamID={this.streamID}
              posterID={this.props.data.actor.id}
              workout={this.props.data.workout}
              text={text}
              image={media_url}
              type="post"
              eventStatusPost={this.type === 'event'}
              groupID={this.props.data?.group}
              eventID={this.eventID || null}
              tagged={tagged}
              mergeNewPost={this.props.mergeNewPost}
            />
          </div>
        </div>
        {this.type === 'event' && <EnhancedCard event={event} />}

        <Link
          to={{
            pathname: this.determinePostRoute(),
            state: this.navigationState()
          }}
          onClick={() => { history._commentUpdateCallback = this.updateCommentCount; }}>
          {this.props.data.workout ? (
            <ShareChallengeBox
              eventName={this.props.data.workout.event_name}
              chapterName={this.props.data.workout.chapter_name}
              eventStartTime={
                this.props.data.workout.event_start_time
              }
              miles={this.props.data.workout.miles}
              steps={this.props.data.workout.steps}
              hours={Math.floor(
                this.props.data.workout.minutes / 60,
              )}
              minutes={Math.floor(
                this.props.data.workout.minutes % 60,
              )}
              seconds={Math.round(
                (this.props.data.workout.minutes % 1) * 60,
              )}
            />
          ) : null}
          <FormattedPostText
            text={text}
            tagged={tagged}
            linkableUsers={false}
            history={history}
            clickable={false}
            links={links}
          />
        </Link>
        {links.length && open_graph?.url ? (
          <SitePreviewCard
            key={links[links.length - 1]}
            link={links[links.length - 1]}
            graphData={open_graph}
          />
        ) : null}
        {media_url && (
          <div
            className={
              this.state.tallImg
                ? `${styles.tallContainer} ${styles.postImageContainer}`
                : styles.postImageContainer
            }>
            <img
              className={[
                this.state.tallImg
                  ? `${styles.tallImage} ${styles.postImage}`
                  : styles.postImage,
              ]}
              src={media_url}
              alt="User Post Image"
              onClick={() => this.setState({isModalOpen: true})}
              onLoad={this.onImgLoad}
            />
          </div>
        )}
        {this.reactable && !tenantProjectInfo.getValue("communityMemberPostingOnly") ? (
          <div className={styles.reactionContainer}>
            <div className={styles.likeContainer}>
              <span className={styles.likeIconClickable} onClick={this.handleLikePost}>
                <LikeIcon  
                  className={styles.likeIcon}
                  tintColor={liked ? 'var(--primary)' : null}
                />
              </span>
              {likeAmount > 0 ? (
                <p className={`namesAndObjects`} onClick={this.handleClickLikeList}>
                  {likeAmount} {likeAmount > 1 ? 'Likes' : 'Like'}
                </p>
              ) : null}
            </div>
            <div
              className={styles.commentsContainer}
              onClick={() => {
                history._commentUpdateCallback = this.updateCommentCount;
                history.push({
                  pathname: this.determinePostRoute(),
                  state: this.navigationState()
                });
              }}>
              <p>{`${commentAmount} ${
                commentAmount > 1 ? 'comments' : 'comment'
              }`}</p>
            </div>
          </div>
        ) : null}
        {isModalOpen && (
          <PhotoView
            post_image={media_url}
            onModalClose={() => this.setState({isModalOpen: false})}
            liked={liked}
            likeAmount={likeAmount}
            onLikeClicked={this.handleLikePost}
          />
        )}
      </div>
    ) : null;
  }
}

export default withRouter(AggregateFeedListItem);
